import React from 'react';

const Welcome = () => {
    return (
        <div>
            ami holam welcome page
        </div>
    );
};

export default Welcome;